import React from 'react'
import PageLayout from '../../../components/layouts/PageLayout'
import ContactFormContainer from '../../../containers/ContactFormContainer'
import SectionHeading from '../../../components/Heading'
import { withNamespaces } from 'react-i18next'

export const View = props => {
	const { t } = props
	return <PageLayout>
		<div className='c-content'>
			<div className='o-wrapper u-padding-vertical'>
				<div className='o-layout o-layout--center'>
					<div className='o-layout__item u-1/1 u-1/2@tablet'>
						<SectionHeading priority={1} text={t('contactForm.title')} classes='' />
						<ContactFormContainer />
					</div>
				</div>
			</div>
		</div>
	</PageLayout>
}

export default withNamespaces()(View)



// WEBPACK FOOTER //
// ./src/routes/Contact/components/View.js